/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */
import { NgModule } from '@angular/core';
import { HighlightSearch } from './highlight';
import { KeysPipe } from './keys';
import { MaxPipe } from './max';
import { PanelClass } from './panel_class';
import { RangePipe } from './range';
import { TranslateClass } from './translate';
import { LinkifyPipe } from './linkify';

const PIPES = [
    HighlightSearch,
    KeysPipe,
    MaxPipe,
    PanelClass,
    RangePipe,
    TranslateClass,
    LinkifyPipe,
];

@NgModule({
    declarations: [...PIPES],
    exports: [...PIPES]
})
export class CommonPipes {}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/pipes/index.ts